var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select-goods" }, [
    _c(
      "div",
      { staticClass: "data-preview clearfix" },
      [
        _c(
          "draggable",
          _vm._b(
            { attrs: { list: _vm.selectedItems } },
            "draggable",
            { animation: 120, filter: "input", preventOnFilter: false },
            false
          ),
          _vm._l(_vm.selectedItems, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "data-item" },
              [
                _c("a-icon", {
                  staticClass: "icon-close",
                  attrs: { theme: "filled", type: "close-circle" },
                  on: {
                    click: function ($event) {
                      return _vm.handleDeleteItem(index)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  [
                    _c("template", { slot: "title" }, [
                      _c("span", { staticClass: "f-12" }, [
                        _vm._v(_vm._s(item.goods_name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-inner" }, [
                      _c("div", { staticClass: "item-image" }, [
                        _c("img", {
                          attrs: { src: item.goods_image, alt: "" },
                        }),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          0
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "data-add" },
      [
        _c(
          "a-button",
          {
            attrs: { icon: "plus" },
            on: {
              click: function ($event) {
                return _vm.handleSelectGoods()
              },
            },
          },
          [_vm._v("选择商品")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }